import * as types from '../actions/types';


const initialState = {
  results: null,
  refinements: null,
  inFlight: false,
};

export default function searchResultsReducer(state = initialState, action) {
  switch (action.type) {
    case types.IN_FLIGHT:
      return {
        ...state,
        inFlight: true,
      };
    case types.RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        refinements: action.searchResults.refinements,
        results: action.searchResults.results,
        inFlight: false,
      };
    default:
      return state;
  }
}
